
































import { auth as authStore, doctor as doctorStore, patient as patientStore } from "@/store/modules";
import { inject } from 'inversify-props';
import { Component, Vue } from "vue-property-decorator";
import { emailRules } from "@/utils/validation";
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { IAuthService } from '@/interfaces/Services';

@Component({})
class ChangeEmailCard extends Vue {
  @inject(DependencyIdentifiers.AuthService)
  private authService!: IAuthService;

  private enabled = false;
  private formData = {
    email: ""
  };
  private get formConfig() {
    return {
      email: {
        label: this.$t('account.email'),
        rules: [(v: string | undefined) => !!v || this.$t('validator.required'), ...emailRules],
        show: false
      }
    };
  }

  async submit() {
    // @ts-ignore
    if (!this.$refs.form.validate()) {
      return;
    }
    this.isLoading = true;
    try {
      await this.authService.changeEmail(this.formData.email);
    } finally {
      this.isLoading = false;
    }
  }

  async mounted() {
    if (authStore.isPatient) {
      this.formData.email = patientStore.items[`${authStore.authPatientId}`].email;
    } else {
      this.formData.email = doctorStore.items[`${authStore.authDoctorId}`].contactEmail;
    }
    this.enabled = true;
    this.isLoading = false;
  }

  isLoading = false;

  get disabled() {
    return this.enabled === false;
  }

  set disabled(value: boolean) {
    this.enabled = value === false;
  }
}

export default ChangeEmailCard;
